import * as yup from 'yup';
import React, { useEffect } from 'react';
import { buildValidationObject } from '../../../util/form';

export const restorationFormQuestion = (formValues = undefined, isMarieGroup = false) => {
    const object = {
        1: {
            component: 'CheckboxRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.toolsToOrder',
            name: 'toolsToOrder',
            showSingleError: false,
            notShowOrder: true,
            option: [
                {
                    value: 'option.gingivalReductionGuide',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.gingivalReductionGuide',
                },
                {
                    value: 'option.incisalPreparationGuide',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.incisalPreparationGuide',
                },
                {
                    value: 'option.preparationCheckGuide',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.preparationCheckGuide',
                },
                {
                    value: 'option.indexFinalSimulationTemporization',
                    label: '@PatientInfo.smileDesign.prescriptionNotes.option.indexFinalSimulationTemporization',
                },
                {
                    value: isMarieGroup ? 'option.temporaryRestorationRetainerAligner' : 'option.temporaryRestoration',
                    label: isMarieGroup
                        ? '@PatientInfo.smileDesign.prescriptionNotes.option.temporaryRestorationRetainerAligner'
                        : '@PatientInfo.smileDesign.prescriptionNotes.option.temporaryRestoration',
                },
                {
                    value: isMarieGroup ? 'option.bleachingTray' : 'option.bleachingTrayPreOperation',
                    label: isMarieGroup
                        ? '@PatientInfo.smileDesign.prescriptionNotes.option.bleachingTray'
                        : '@PatientInfo.smileDesign.prescriptionNotes.option.bleachingTrayPreOperation',
                },
            ],
            validation: yup.array().required('Required').typeError('Required').min(1, 'Required'),
        },
        2: {
            component: 'TextFieldRhf',
            question: '@PatientInfo.smileDesign.prescriptionNotes.question.remark',
            name: 'restorationRemark',
            showSingleError: false,
        },
    };

    return object;
};

// @ts-ignore
export const validationSchemaRestorationForm = yup.object().shape(buildValidationObject(restorationFormQuestion()));
